import React from "react";
import InputWrapper from "./InputWrapper";
import { TextField, Tooltip } from "@mui/material";
import ReadOnlyInput from "./ReadOnlyInput";
import { Controller } from "react-hook-form";
import { DEFAULT_SIZE } from "../../../utils/constant";
import PropTypes from "prop-types";
import HelpIcon from "@mui/icons-material/Help";
export default function ProTextInput({
  name,
  mode = "edit",
  label,
  placeholder,
  rules,
  control,
  type = "text",
  fieldProps = {},
  size = DEFAULT_SIZE,
  startAdornment = null,
  isAddMode,
  disabled,
  onCustomBlur,
  withInfoIcon = false,
  infoMessage = "",
  labelAdornment = null,
  ...rest
}) {
  const { canView = false, canAdd = false, canEdit = false } = rest.permission || {};
  if (!canView || (isAddMode && !canAdd)) return null;

  const editModeAllowed = isAddMode ? canAdd : canEdit;
  if (mode === "read" || (mode === "edit" && !editModeAllowed))
    return <ReadOnlyInput type={type} size={size} name={name} label={label} {...rest} rules={rules} />;

  const handleKeyDown = e => {
    if (type === "number" && (e.key === "e" || e.key === "E")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <InputWrapper size={size}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, onBlur, value = "" }, fieldState: { error } }) => {
          const { onChange: fieldOnChange, onBlur: fieldOnBlur, value: fieldValue, ...restFieldProps } = fieldProps;

          return (
          <div className="proInputWithMessage" style={{display: "flex", alignItems: "center", gap: "6px", width: "100%"}}>
            <div className={withInfoIcon ? "proInputWithMessage-input" : "proInputWithMessage-input-full"} style={{ flex: 1 }}>
                <TextField
                  onChange={e => {
                    onChange(e.target.value);
                    fieldOnChange?.(e);
                  }}
                  onBlur={e => {
                    const trimmedValue = e.target.value.trim();
                    if (value !== trimmedValue) {
                      onChange(trimmedValue);
                    }

                    if (typeof onCustomBlur === "function") {
                      onCustomBlur(e);
                    }

                    fieldOnBlur?.(e);

                    onBlur();
                  }}
                  value={value}
                  label={
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                      {label}
                      {rules?.required && <span style={{ color: "red" }}> *</span>}
                      {labelAdornment}
                    </span>
                  }
                  disabled={disabled}
                  variant="outlined"
                  fullWidth
                  type={type}
                  placeholder={placeholder || label}
                  onKeyDown={handleKeyDown}
                  InputProps={{ startAdornment }}
                  InputLabelProps={{ shrink: true }}
                  helperText={error?.message || null}
                  error={!!error}
                  multiline={rest.multiline}
                  minRows={rest.minRows}
                  {...restFieldProps}
                />
            </div>
            {withInfoIcon && (
              <div className="proInputWithMessage-info">
                <Tooltip title={infoMessage} placement="top">
                  <HelpIcon color="primary" />
               </Tooltip>
              </div>
            )}
          </div>
          );
        }}
      />
    </InputWrapper>
  );
}

ProTextInput.propTypes = {
  name: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(["read", "edit"]).isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rules: PropTypes.object.isRequired,
  startAdornment: PropTypes.node,
  control: PropTypes.object.isRequired,
  type: PropTypes.string,
  isAddMode: PropTypes.bool,
  fieldProps: PropTypes.object,
  permission: PropTypes.shape({
    canView: PropTypes.bool,
    canAdd: PropTypes.bool,
    canEdit: PropTypes.bool
  }),
  formValues: PropTypes.object,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  withInfoIcon: PropTypes.bool,
  infoMessage: PropTypes.string
};